$('.js-form-modal-watchdog').validate({
    submitHandler: function(form) {
        $(form).find('[type="submit"]')
            .prop('disabled', true)
            .addClass('is-loading');

        window.assignRecaptchaResponseToForm(form).then(function() {
            Form.ajaxPost(form, function (data) {
                $('.js-watchdog-error').hide();
                $('.js-watchdog-success').hide();

                if (!data.status) {
                    $('.js-watchdog-error')
                        .text(data.message)
                        .slideDown(250);
                } else {
                    $('.js-watchdog-success')
                        .text(data.message)
                        .slideDown(250);
                }

                $(form).find('[type="submit"]')
                    .prop('disabled', false)
                    .removeClass('is-loading');
            }, 'json');
        });
    }
});